<template>
    <div class="report-wrap">
        <div class="report-item" v-for="(item, index) in arrDataReport" :key="index">
            <div class="title-one">{{ item.title }}</div>
            <template v-for="(it, itIndex) in item.process">
                <div class="content-wrap">
                    <div class="open-wrap" @click="it.open = !it.open">
                        <div class="open-left">
                            {{ it.title }}
                        </div>
                        <div class="open-right">
                            <span>{{ it.quality_point_title }}</span>
                            <img :style="{ 'transform': it.open ? 'rotate(-90deg)' : 'rotate(90deg)' }"
                                src="@/assets/images/share/jt.png" alt="">
                        </div>
                    </div>
                    <!-- 可显示隐藏数据 -->
                    <div class="open-active" :style="{ 'height': it.open ? 'auto' : '0', 'overflow': 'hidden' }">
                        <div class="qualified-wrap">
                            <div class="content">
                                <span>{{ it.tips }}</span>
                                <img src="@/assets/images/share/ys.png" alt="">
                            </div>
                        </div>
                        <div class="tag-wrap">
                            <template v-for="i in it.tag_list">
                                <div class="tag-item" :class="{ 'tag-item-active': i.active }"
                                    @click="changeTag(index, itIndex, i.tag_id)">{{ i.tag_name }}</div>
                            </template>
                        </div>
                        <div class="swiper" v-if="it.tag_list.length > 0 && it.tag_list[it.cateTagCurrent].arrImg.length">
                            <van-swipe class="my-swipe" :show-indicators="false" :ref="'vanSwiper' + index + itIndex" :loop="true" @change="swiperChannge($event,it.cateTagCurrent,it)">
                                <template v-for="(iTage,iTageIndex) in it.tag_list[it.cateTagCurrent].arrImg">
                                    <van-swipe-item class="my-swipe-item" @click="priview(it.tag_list[it.cateTagCurrent].arrImg,iTageIndex)">
                                        <img v-lazy="iTage"  alt="">
                                    </van-swipe-item>
                                </template>
                            </van-swipe>
                            <div class="indicators">
                                <template v-for="(iTage,iTageIndex) in it.tag_list[it.cateTagCurrent].arrImg">
                                    <div class="indicators-item" :class="{'indicators-item-active':iTageIndex==it.tag_list[it.cateTagCurrent].imgCurrent}"></div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div  v-if="it.tag_list.length > 0" class="img-wrap">
                        <template v-for="(iTage,iTageIndex)  in it.tag_list[it.cateTagCurrent].arrImg">
                            <div class="img-item" @click="changeImgCurrent(it.cateTagCurrent,it,iTageIndex,index,itIndex)"  :class="{'img-active':iTageIndex==it.tag_list[it.cateTagCurrent].imgCurrent}">
                                <img v-lazy="iTage" alt="">
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </div>
        <!-- 预览图片 -->
        <van-image-preview v-model="imgShow" :closeable="true" :startPosition="lookImgIndex"  :images="arrStausImg"></van-image-preview>
        <!-- 返回按钮-->
        <img src="@/assets/images/antV2/back-icon02.png" class="back-icon" @click="toBack" alt="">
    </div>
</template>
<script>
import { getReport } from '@/js/project/share.js'
export default {
    data() {
        return {
            imgShow: false,
            arrStausImg: [],
            lookImgIndex: 0,
            arrId: [],//id
            arrDataReport: [],
            arrDataReportA: [],
            nCount: 0,
        }
    },
    created() {
        this.arrId = this.$route.query.id.split(',') || []
        console.log(this.arrId, '===>')
        if (this.arrId.length) {
            this.arrId.forEach((it) => {
                this.getReportInfo(it, this.$route.query.project_uuid)
            })
        }
    },
    methods: {
        // 返回上一页
        toBack(){
            this.$router.back()
        },
        priview(arr,index){
            this.lookImgIndex = index;
            this.imgShow = true;
            this.arrStausImg = arr;
        },
        // 切换轮播
        swiperChannge(event,index,it){
            it.tag_list[index].imgCurrent=event
        },
        // 切换图片
        changeImgCurrent(index,it,itIndex,itIndexS,itIndexN){
            it.tag_list[index].imgCurrent=itIndex
            console.log(`vanSwiper${itIndexS}${itIndexN}`)
            this.$refs[`vanSwiper${itIndexS}${itIndexN}`][0].swipeTo(itIndex)
            // 显示预览图片
            this.lookImgIndex = itIndex;
            this.imgShow = true;
            this.arrStausImg = it.tag_list[index].arrImg;
        },
        // 伸缩
        openChange(index, itxo) {
            this.arrDataReport.forEach((item, itx) => {
                if (index == itx) {
                    item.process.forEach((it, itIn) => {
                        if (itxo == itIn) {
                            it.open = !it.open
                        } else {
                            it.open = false
                        }
                    })
                } else {
                    item.process.forEach((it, itIn) => {
                        it.open = false
                    })
                }
            })
        },
        // 切换质控点
        changeTag(index, itIndex, id) {
            this.arrDataReport.forEach((item, itx) => {
                if (index == itx) {
                    item.process.forEach((it, itIn) => {
                        if (itIndex == itIn) {
                            it.tag_list.forEach((i, io) => {
                                if (i.tag_id == id) {
                                    i.active = true
                                    it.cateTagCurrent = io
                                } else {
                                    i.active = false
                                }
                            })
                        }
                    })
                }
            })
        },
        getReportInfo(rule_report_id, projectmgnid) {
            let that = this
            getReport({
                rule_report_id: rule_report_id,
                projectmgnid: projectmgnid
            }).then(res => {
                let obj = {}
                obj.title = res.data.result.title
                obj.process = res.data.result.process.map((it, index) => {
                    if (index == 0) {
                        it.open = true
                    } else {
                        it.open = false
                    }
                    if(it.tag_list.length > 0){
                        it.tag_list.forEach((i, itx) => {
                            i.arrImg = it.photo_list[i.tag_id]
                            i.imgCurrent = 0
                            if (itx == 0) {
                                i.active = true
                            } else {
                                i.active == false
                            }
                        })
                    }
                    it.cateTagCurrent = 0
                    return it
                })
                // this.nCount++
                this.arrDataReport.push(obj)
                // if(this.nCount==this.arrId.length-1){
                //     this.arrDataReport=this.arrDataReportA
                // }
                console.log(this.arrDataReport, '详情')
            })
        }

    }
}
</script>
<style lang="scss" scoped>
.back-icon{
    position: fixed;
    z-index: 99;
    right: 10px;
    bottom: 50px;
    width: 140px;
}
* {
    box-sizing: border-box;
}

.report-wrap {
    padding-bottom: 50px;

    .report-item {
        width: 686px;

        margin: 32px auto 0;

        .title-one {
            margin-bottom: 20px;
            height: 80px;
            line-height: 80px;
            font-size: 30px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
            background: #275BA6;
            padding: 0px 32px;
            border-radius: 24px;
        }

        .content-wrap {
            background: rgba(39, 91, 166, 0.09);
            border-radius: 24px;
            margin-bottom: 20px;
        }

        .open-wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px 0 32px;
            height: 72px;
            background: rgba(53, 93, 75, 0.05);
            border-radius: 24px 24px 0px 0px;

            .open-left {
                font-size: 24px;
                font-weight: bold;
                color: #275BA6;
            }

            .open-right {
                display: flex;
                align-items: center;

                span {
                    font-size: 22px;
                    font-weight: 500;
                    color: #275BA6;
                }

                img {
                    width: 40px;
                    height: 40px;
                    margin-left: 20px;
                    transform: rotate(-90deg);
                    transition: all .5s;
                }
            }
        }

        .qualified-wrap {
            padding: 0 32px;
            margin-bottom: 30px;

            .content {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;
                padding-bottom: 20px;
                width: 624px;
                border-bottom: 1px solid #D1DAD6;

                span {
                    font-size: 26px;
                    font-weight: 400;
                    color: #666666;
                }

                img {
                    width: 124px;
                }
            }
        }

        .tag-wrap {
            display: flex;
            width: 100%;
            overflow-x: scroll;
            overflow-y: hidden;
            white-space: nowrap;
            word-break: break-all;

            .tag-item {
                height: 56px;
                border-radius: 28px;
                border: 2px solid #275BA6;
                font-size: 24px;
                font-weight: bold;
                color: #275BA6;
                line-height: 56px;
                text-align: center;
                padding: 0 28px;
                margin: 0 12px;
            }

            .tag-item-active {
                background: #275BA6;
                color: #ffffff;
            }
        }

        .swiper {
            margin-top: 32px;
            width: 638px;
            height: 360px;
            background: #D8D8D8;
            border-radius: 16px;

            .my-swipe {
                width: 100%;
                height: 100%;
                position: relative;

                .my-swipe-item {
                    width: 100%;
                    object-fit: cover;
                    height: 100%;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }

            .indicators {
                position: absolute;
                bottom: 16px;
                left: 0;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                .indicators-item {
                    width: 16px;
                    height: 16px;
                    background: rgba(53, 93, 75, 0.3);
                    margin-right: 16px;
                    border-radius: 50%;
                }

                .indicators-item-active {
                    background: #275BA6;
                }
            }
        }

        .img-wrap {
            padding: 32px 0 32px 24px;
            width: calc(100% - 24px);
            overflow-x: scroll;
            overflow-y: hidden;
            white-space: nowrap;
            word-break: break-all;

            .img-item {
                width: 96px;
                height: 96px;
                display: inline-block;
                border-radius: 16px;
                margin-right: 20px;
                object-fit: cover;
                background: #275BA6;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 16px;
                }

            }
            .img-active{
                    border: 4px solid #275BA6;
                }
        }
    }
}
</style>
